module.exports = __webpack_public_path__ + "48943048999a1efa8ad7488278aa5eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_icon.png
// module id = 25
// module chunks = 0 1 2 3 4